import DatePicker, {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

export const PickDate = ({label , placeholder , timestamp, onChange}) => {

    const date = new DateObject({
        date: timestamp ? new Date(timestamp * 1000) : new Date(),
        calendar: persian,
        locale: persian_fa
    })

    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2">{label}</label>}
                <DatePicker
                    placeholder={placeholder}
                    value={date}
                    format="YYYY/MM/DD"
                    inputClass={'form-control text-input'}
                    containerClassName={"d-block"}
                    calendar={persian}
                    locale={persian_fa}
                    onChange={(date) => {
                        date.hour = date.minute =  date.second = 0;
                        onChange(date.unix);
                    }}
                />
            </div>
        </div>
    );
}
export const PickDateWithoutContainer = ({label , placeholder , timestamp, onChange}) => {

    const date = new DateObject({
        date: timestamp ? new Date(timestamp * 1000) : new Date(),
        calendar: persian,
        locale: persian_fa
    })

    return (
        <div className="">
            {label && <label className="card-title mb-2">{label}</label>}
            <DatePicker
                placeholder={placeholder}
                value={date}
                format="YYYY/MM/DD"
                inputClass={'form-control text-input'}
                containerClassName={"d-block"}
                calendar={persian}
                locale={persian_fa}
                onChange={(date) => {
                    date.hour = date.minute =  date.second = 0;
                    onChange(date.unix);
                }}
            />
        </div>
    );
}
export const PickDateTime = ({label , placeholder , timestamp, onChange , ...rest}) => {

    const date = new DateObject({
        date: timestamp ? new Date(timestamp * 1000) : new Date(),
        calendar: persian,
        locale: persian_fa
    })

    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2">{label}</label>}
                <DatePicker
                    {...rest}
                    placeholder={placeholder}
                    value={date}
                    format="HH:mm:ss YYYY/MM/DD"
                    inputClass={'form-control text-input'}
                    containerClassName={"d-block"}
                    calendar={persian}
                    locale={persian_fa}
                    onChange={(date) => {
                        onChange(date.unix);
                    }}
                    plugins={[
                        <TimePicker position="bottom" />
                    ]}
                />
            </div>
        </div>
    );
}
export const PickDateTimeWithoutContainer = ({label , placeholder , timestamp, onChange , ...rest}) => {

    const date = new DateObject({
        date: timestamp ? new Date(timestamp * 1000) : new Date(),
        calendar: persian,
        locale: persian_fa
    })

    return (
        <div className="">
            {label && <label className="card-title mb-2">{label}</label>}
            <DatePicker
                {...rest}
                placeholder={placeholder}
                value={date}
                format="HH:mm:ss YYYY/MM/DD"
                inputClass={'form-control text-input'}
                containerClassName={"d-block"}
                calendar={persian}
                locale={persian_fa}
                onChange={(date) => {
                    onChange(date.unix);
                }}
                plugins={[
                    <TimePicker position="bottom" />
                ]}
            />
        </div>
    );
}